import React from 'react';
import { get,  } from 'lodash';
import { actionItemDetailInnerWidget as ActionItemDetailInnerWidgetView } from 'ui/views/widgets/actionItemDetailInnerWidget';
import { ActionItemDetailInnerWidgetService } from 'services/actionItemDetailInnerWidget';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { ActionItemDetailInnerWidget } from 'ui/containers/ActionItemDetailInnerWidget';
 *
 * // render
 * <ActionItemDetailInnerWidget propName='propValue'/>
 */
export class ActionItemDetailInnerWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );
        
        this.actionItemDetailInnerWidgetService = new ActionItemDetailInnerWidgetService();
        this.state={
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
            requestPayload: { data: this.props.widget.requestPayload, ...this.props.requestPayload }
        };
        if( this.state.requestPayload ) {
            this.fetchComponentData(); // start component data fetch
        }
        
    }

    /**
	 * @desc Fetch component response.
	 */
    async fetchComponentData() {

        log.debug( 'ActionItemDetailInnerWidget.fetchComponentData()' );

        // cancel ongoing request
        this.actionItemDetailInnerWidgetService.cancel();

        // get status and service data
        const { status, data } = await this.actionItemDetailInnerWidgetService.fetchComponentData( {
            url: this.props.widget.url,
            data: this.state.requestPayload
        } );
        
        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <ActionItemDetailInnerWidgetView
            isFetching={ this.state.isFetching }
            networkStatus={ this.state.networkStatus }
            { ...get( this.state, 'componentData', {} ) }
            requestPayload={  this.state.requestPayload }/>
        );
    }
}

// set display name
ActionItemDetailInnerWidget.displayName = 'ActionItemDetailInnerWidget';

// set default props
ActionItemDetailInnerWidget.defaultProps = {};

// prop types
ActionItemDetailInnerWidget.propTypes = {};
